import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {BinKeysService} from '../../services/bin-keys.service';
import {OverlayPanel} from 'primeng/overlaypanel';
import {BaseClientComponent} from '../base-client.component';
import {TechnicalPopService} from '../../services/technical-pop.service';

@Component({
  selector: 'app-admin-encryption-keys',
  templateUrl: './admin-encryption-keys.component.html',
  styleUrls: ['./admin-encryption-keys.component.scss']
})
export class AdminEncryptionKeysComponent extends BaseClientComponent implements OnInit {
  availableKeys = false;
  keysInformation = [];
  pops = [];
  numberOfProdKeys: string;
  numberOfUatKeys: string;
  channelSelected: string;
  popSelected: string;
  loading = true;
  weekDisplayed: string;

  constructor(public authenticationService: AuthenticationService,
              protected technicalPopService: TechnicalPopService,
              public binKeysService: BinKeysService) {
    super();
  }

  ngOnInit() {
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.getKeysInformation();
    });
    this.subscriptions.push(response$);
  }

  private getKeysInformation() {
    this.binKeysService.getKeysInformation().subscribe({
        next: binKeysInformation => {
          if (binKeysInformation.length !== 0) {
            this.pops = binKeysInformation['pops'];
            this.formattedData(binKeysInformation['formattedData']);
            this.weekDisplayed = binKeysInformation['date'];
            this.availableKeys = true;
            this.loading = false;
          }
        }, error: () => {
          this.loading = false;
        }
      }
    );
  }

  private formattedData(binKeysInformation: any) {
    for (const element in binKeysInformation) {
      this.keysInformation.push({
        channel: element,
        pops: binKeysInformation[element]
      });
    }
  }

  displayItem(event, keyInformation, pop, overlayPanel: OverlayPanel) {
    this.channelSelected = keyInformation['channel'];
    this.popSelected = pop;
    this.numberOfProdKeys = keyInformation['pops'][pop].prod;
    this.numberOfUatKeys = keyInformation['pops'][pop].uat;
    overlayPanel.toggle(event);
  }
}
